import { GameState } from "../level.js";
// The two interfaces are structually equivalent, so just output both!
export function msToProtoTime(ms) {
    const seconds = Math.floor(ms / 1000);
    const micros = ms - seconds * 1000;
    return {
        seconds,
        nanos: micros * 1000,
    };
}
export function protoTimeToMs(protoTime) {
    return (protoTime.seconds ?? 0) * 1000 + (protoTime.nanos ?? 0) / 1000;
}
export function protoTimeToSubticks(protoTime) {
    return ((protoTime.seconds ?? 0) * 60 +
        Math.round((protoTime.nanos ?? 0) / 1000 / (1000 / 60)));
}
export class StepRecorder {
    constructor() {
        this.currentStep = -1;
        this.attemptSteps = new Uint8Array(100);
    }
    reallocateStepArray() {
        let newLength = this.attemptSteps.length * 1.5;
        // Makes sure we always have space to save the last time amount
        if (newLength % 2 === 1)
            newLength += 1;
        const newArr = new Uint8Array(newLength);
        newArr.set(this.attemptSteps);
        this.attemptSteps = newArr;
    }
    recordAttemptStep(input) {
        if (this.currentStep === -1) {
            this.attemptSteps[0] = input;
            this.attemptSteps[1] = 1;
            this.currentStep += 1;
            return;
        }
        let stepPos = this.currentStep * 2;
        const lastStep = this.attemptSteps[stepPos];
        if (this.attemptSteps[stepPos + 1] >= 0xfa || input !== lastStep) {
            this.currentStep += 1;
            stepPos += 2;
            if (stepPos >= this.attemptSteps.length) {
                this.reallocateStepArray();
            }
            this.attemptSteps[stepPos] = input;
        }
        this.attemptSteps[stepPos + 1] += 1;
    }
    finalizeSteps() {
        return this.attemptSteps.slice(0, this.currentStep * 2 + 1);
    }
}
export class AttemptTracker {
    constructor(playerN, blobMod, randomForceFloorDirection, scriptState) {
        this.attemptStartTime = Date.now();
        this.stepRecorders = [];
        for (let idx = 0; idx < playerN; idx += 1) {
            this.stepRecorders.push(new StepRecorder());
        }
        this.currentAttempt = {
            attemptStart: msToProtoTime(Date.now()),
            solution: {
                levelState: {
                    randomForceFloorDirection: randomForceFloorDirection,
                    cc2Data: { blobModifier: blobMod, scriptState },
                },
            },
        };
    }
    recordAttemptStep(level) {
        const seats = level.playerSeats;
        for (let idx = 0; idx < seats.length; idx += 1) {
            this.stepRecorders[idx].recordAttemptStep(seats[idx].inputs);
        }
    }
    endAttempt(level) {
        if (!this.currentAttempt ||
            !this.currentAttempt.solution ||
            this.attemptStartTime === undefined)
            throw new Error("The attempt must start before it can end.");
        this.currentAttempt.attemptLength = msToProtoTime(Date.now() - this.attemptStartTime);
        if (level.gameState !== GameState.WON) {
            // If we didn't win, scrap the solution info
            delete this.currentAttempt.solution;
        }
        if (level.gameState === GameState.PLAYING) {
            // Noop when the attempt is ended prematurely
        }
        else if (level.gameState === GameState.TIMEOUT) {
            this.currentAttempt.failReason = "time";
        }
        else if (level.gameState === GameState.DEATH) {
            // FIXME: Add `Level.death_reason`
            // this.currentAttempt.failReason = level.selectedPlayable?.deathReason
        }
        else {
            this.currentAttempt.solution.outcome = {
                bonusScore: level.bonusPoints,
                timeLeft: msToProtoTime(level.timeLeft * (1000 / 60)),
                absoluteTime: msToProtoTime(level.msecsPassed()),
            };
            this.currentAttempt.solution.steps = this.stepRecorders.map(rec => rec.finalizeSteps());
            this.currentAttempt.solution.usedGlitches = Array.from(level.glitches, glitch => glitch.toGlitchInfo());
        }
        return this.currentAttempt;
    }
}
//# sourceMappingURL=attemptTracker.js.map